export const Label = ({ htmlFor, value, className, required } : { htmlFor? : string, value: string, className?: string, required?: boolean }) => {
    return (
        <div className={`block text-base ${className}`}>
            <label htmlFor={htmlFor}>{value } { required && <span className="text-red-600">*</span> }</label> 
        </div>
    )
}